import api from '@/apis'

export const fetchConversations = params => api.get(`/task`, {
  params
})

export const updateConversation = (id, data) => api.put(`/conversations/${id}`, data)
export const markRead = id => api.put(`/conversations/${id}/mark_read`)
export const getConv = id => api.get(`/conversations/${id}`)
export const getConvStats = type => api.get(`/conversations/stats/${type}`)
export const closeMessageOrder = params => api.get(`/closeMessageOrder`, { params })
export const messageRetract = params => api.delete(`/order/message/retract/${params.id}`, { params })
export const saveOrderConfirmFee = data => api.post(`/tenant/order/confirmFee/${data.orderId}`, data)
